// @ts-nocheck
import { get, merge, includes } from 'lodash';
import Raven from 'raven-js';
import { PASSPORT_CLIENT_NAME } from 'library-components/config/envConfig.js';
import { getVar } from 'library-components/utils/environment';
let currentPage = '';
function getCookie(cookieName) {
    const strCookie = document.cookie;
    const arrCookie = strCookie.split('; ');
    for (let i = 0; i < arrCookie.length; i += 1) {
        const arr = arrCookie[i].split('=');
        if (cookieName === arr[0]) {
            return arr[1];
        }
    }
    return '';
}
let unpushedTrackEventsStack = [];
let unpushedPendoTrackEventsStack = [];
export default (page, opts = {}) => {
    const cid = getCookie('CLIENT_ID');
    let init = false;
    currentPage = page;
    const anonymousId = 'anonymousId00000';
    const email = opts.email || '';
    const accountId = opts.accountId || anonymousId;
    const companyId = opts.companyId || '';
    const companyName = opts.companyName || '';
    const userType = opts.userType || '';
    let environment = window.location.host.split('.')[0];
    environment = environment === '127' ? 'dev' : environment;
    if (environment !== 'dev' && window.location.search.indexOf('noraven=1') < 0) {
        const data = {
            id: accountId,
            email,
            account_id_cipher: accountId,
            company_id_cipher: companyId,
            company_name: companyName,
            user_type: userType,
        };
        if (cid) {
            Object.assign(data, { client_id: cid });
        }
        Raven.setUserContext(data);
        import('@patsnap/common-ps-tracer')
            .then(m => (m.default ? m.default : m))
            .then(sentryPsPlugin => {
            sentryPsPlugin(Raven, {
                product: 'Account',
                page: page,
                openSpendTimeTrack: true,
            });
        })
            .then(() => {
            unpushedTrackEventsStack.forEach(trackData => {
                Raven.insertMeta(trackData);
            });
            unpushedTrackEventsStack = [];
            if (unpushedPendoTrackEventsStack.length) {
                unpushedPendoTrackEventsStack.forEach(trackData => {
                    if (window.pendo && window.pendo.track) {
                        window.pendo.track(trackData.action, {
                            module: trackData.category,
                            ...trackData.attr,
                        });
                    }
                });
                unpushedPendoTrackEventsStack = [];
            }
        });
    }
    if (!init) {
        init = true;
    }
};
const RavenInsertMeta = (category, action, attr) => {
    if (!Raven.insertMeta) {
        return;
    }
    const region = get(window, 'zPREFACE.region', 'us').toUpperCase();
    attr = merge({
        source: get(window, 'zPREFACE.trackData.source', category),
        region,
    }, attr);
    if (includes(['Login', 'Public'], currentPage)) {
        attr.product_from = getVar('from') || PASSPORT_CLIENT_NAME;
    }
    const trackData = {
        module: category,
        action,
        attr,
    };
    Raven.insertMeta(trackData);
};
function PendoInsertMeta(category, action, attr) {
    RavenInsertMeta(category, action, attr);
}
Raven.insertMeta = Raven.insertMeta
    ? Raven.insertMeta
    : (trackData) => {
        console.warn('ps-tracer not inited!');
        unpushedTrackEventsStack.push(trackData);
    };
export { RavenInsertMeta, Raven, PendoInsertMeta, };
